
// import React from "react";
// import { useQuery, useMutation } from "react-query";
// import toast from "react-hot-toast";
// import { exams } from "../../../../../../api/exams";
// import { useTranslation } from "react-i18next";
// import { convertTo12Hour } from "../../../../../../utils/dateTimeFormatter";

// function BookexamModal({ closeModal, refetch }) {
//   const { t } = useTranslation();
//   const user = JSON.parse(sessionStorage.getItem("user"));
//   const activeExam = JSON.parse(sessionStorage.getItem("active-exam"));
//   const userId = user?.user?.user_id || window.sessionStorage.getItem("user_id");
//   const isEdit = activeExam?.booked_date;
//   const { isLoading, data: bookings } = useQuery(["get bookings"], async () => {
//     const res = await exams.getBookingsv3(userId, activeExam?.assessment_id);
//     return res?.data || [];
//   });

//   const { mutateAsync: createBooking, isLoading: isBooking } = useMutation(exams.createBookingv3, {
//     onSuccess: () => {
//       toast.success(t("booking-success"));
//       refetch();
//       closeModal(false);
//     },
//     onError: (error) => {
//       toast.error(error?.response?.data?.error || t("booking-failed"));
//     },
//   });

//   const handleBook = async (bookingId) => {
//     try {
//           toast.loading(t("booking-loading"));
//             const response = await createBooking({
//               userId: window.sessionStorage.getItem("user_id") || JSON.parse(sessionStorage.getItem("user"))?.user?.user_id,
//               userExamId: activeExam?.user_exam_id,
//               groupId: bookingId,
//               assessmentId: activeExam?.assessment_id
//             })
//             toast.remove();
//             toast.success(response.message)
//             closeModal(false);
//           }
//           catch (error) {
//             toast.error(error?.response?.data?.message);
//           }
//   };

//   return (
//     <div className="fixed top-0 left-0 w-screen h-screen grid place-items-center bg-black bg-opacity-50 p-4 md:p-10">
//       <div className="w-full md:w-[600px] max-h-[90vh] overflow-y-auto bg-white rounded-2xl md:rounded-[32px] p-6 md:p-8 relative">
//         <h3 className="text-2xl font-bold text-gray-900 mb-4 flex items-start justify-between">
//         {t("book-exam")}
//          <button
//             onClick={() => closeModal(false)}
//             className="bi bi-x-lg  text-darkBlue px-4 md:px-6 py-2 rounded cursor-pointer"
//           />

//         </h3>

//         {isLoading ? (
//           <p className="text-center">{t("loading")}...</p>
//         ) : bookings?.length ? (
//           <div className="flex flex-col gap-4">
//             {bookings.map((booking, index) => (
//               <div
//                 key={booking.id}
//                 className={`border ${
//                    isEdit && activeExam?.booking_info === booking?.title ? "border-primary " : "border-gray-300"
//                   } rounded-lg p-4 flex flex-col gap-2 shadow-sm`}
//               >
//                 <h4 className="text-lg flex justify-between">{booking.title}
//                 { isEdit && activeExam?.booking_info === booking?.title ? <span className="text-primary border rounded-full border-primary px-5 py-1">booked</span> : null}
//                 </h4>
//                 <p className="text-sm text-gray-600">
//                   <strong>{'Start Date'}:</strong>{" "}
//                   {booking.start_date
//                     ? `${new Date(booking.start_date).toLocaleDateString()} ${convertTo12Hour(booking.start_time)}`
//                     : t("not-set")}
//                 </p>
//                 <p className="text-sm text-gray-600">
//                   <strong>{'End Date'}:</strong>{" "}
//                   {booking.end_date
//                     ? `${new Date(booking.end_date).toLocaleDateString()} ${convertTo12Hour(booking.end_time)}`
//                     : t("not-set")}
//                 </p>
//                 {
//                   <div className="flex justify-end">
//                       <button
//                   className="bg-primary text-white py-2 px-16 rounded mt-2 disabled:opacity-50"
//                   onClick={() => handleBook(booking.id)}
//                   data-test-id={`book-exam-${index}`}
//                   disabled={isBooking}
//                 >
//                   {t("book")}
//                 </button>
//                   </div>
//                 }
//               </div>
//             ))}
//           </div>
//         ) : (
//           <p className="text-center text-gray-500">{t("no-bookings-available")}</p>
//         )}

//         <div className="flex justify-end mt-6">
//           <button
//             onClick={() => closeModal(false)}
//             className="border border-darkBlue text-darkBlue px-6 py-2 rounded"
//           >
//             {t("cancel")}
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// }

// export default BookexamModal;

// // import React, { useState, useRef } from "react";
// // import { api } from "../../../../../../api";
// // import { useMutation, useQuery } from "react-query";
// // import toast from "react-hot-toast";
// // import { convertTo12Hour } from "../../../../../../utils/dateTimeFormatter";
// // import { exams } from "../../../../../../api/exams";
// // import { useTranslation } from 'react-i18next';

// // function BookexamModal({ closeModal, refetch }) {
// //   const { t } = useTranslation();
// // const {mutateAsync: createBooking, isLoading: isCreating} = useMutation(exams.createBookingv3)
// //   const [openTime, setOpenTime] = useState(false);
// //   const [openState, setOpenState] = useState(false);
// //   const [openDate, setOpenDate] = useState(false);

// //   const [selectedTime, setSelectedTime] = useState("Select time");
// //   const [selectedState, setSelectedState] = useState("Select state");
// //   const [selectedDate, setSelectedDate] = useState("Select date");
// //   const [selectedDateId, setSelectedDateId] = useState(null);
// //   const [selectOutletId, setSelectOutletId] = useState(null);
// //   const [selectTimetId, setSelectTimeId] = useState(null);
// //   const [availableDates, setAvailableDates] = useState([])
// //   const [availableTimes, setAvailableTimes] = useState([])

// //   const timeRef = useRef(null);
// //   const stateRef = useRef(null);
// //   const dateRef = useRef(null);

// //   const closeOpenMenus = (e) => {
// //     if (timeRef.current && openTime && !timeRef.current.contains(e.target)) {
// //       setOpenTime(false);
// //     }
// //   };
// //   document.addEventListener("mousedown", closeOpenMenus);

// //   const group_id = sessionStorage.getItem("group_id");
// //   const user_group_id = sessionStorage.getItem("user_group_id");
// //   const user = JSON.parse(sessionStorage.getItem('user'));
// //   const examId = JSON.parse(sessionStorage.getItem('active-exam'))?.exam_id

// //   const { isLoading, data, isError, error } = useQuery(["id"], async () => {
// //     const data_ = await exams.getBookingsv2(user?.user?.user_id || window.sessionStorage.getItem("user_id"), examId);
// //     return data_;
// //   }, { select: res => res});

// //   const { isLoading: isLoadingBookings, data: bookings, } = useQuery(["get bookings"], async () => {
// //     const data_ = await exams.getBookingsv3(
// //       user?.user?.user_id || window.sessionStorage.getItem("user_id"), 
// //      JSON.parse(sessionStorage.getItem('active-exam'))?.assessment_id
// //     );
// //     return data_;
// //   }, { select: res => res?.data});

// //   console.log(bookings, "bookings");


// //   const [currentDate, setCurrentDate] = useState({});

// //   const handleTimeSelection = (time) => {
// //     setSelectedTime(time);
// //     setOpenTime(false);
// //   };

// //   const handleBookExam = async (e) => {
// //     e.preventDefault();
// //     if(!selectedDateId){
// //        toast.error(t('please-select-date'));
// //     }
// //     else if (selectedTime === t('select-time') || selectedTime === ""){
// //       toast.error(t('please-select-time'));
// //     }
// //     else {
// //       let payload = {
// //         outlet_id: selectOutletId || null,
// //         date_id: selectedDateId,
// //         preferred_time_slot: selectedTime,
// //         user_exam_id: JSON.parse(sessionStorage.getItem('active-exam'))?.user_exam_id,
// //       };
// //       try {
// //         toast.loading(t('booking-loading'));
// //         const res = await exams.createBookingv2({ 
// //           payload, 
// //           userId: user?.user?.user_id || window.sessionStorage.getItem("user_id"), 
// //           examId
// //         });
// //         toast.remove();
// //         toast.success(res.message);
// //         refetch();
// //         closeModal(false);
// //       } catch (error) {
// //         toast.remove();
// //         toast.error(error?.response?.data?.error);
// //         refetch();
// //       }
// //     }
// //   };

// //   return (
// //     <div className="fixed top-0 left-0 w-screen h-screen grid place-items-center bg-black bg-opacity-50 p-10">
// //       <div className="">
// //         <div className="min-h-[12rem] w-[94%] md:w-[600px] bg-white rounded-[32px] flex flex-col justify-center p-6 md:p-16 relative">
// //           <h3 className="text-lg leading-6 font-medium text-gray-900 mb-4">
// //             {t('book-exam')}
// //           </h3>
// //           <form onSubmit={handleBookExam}>
// //             {(data?.data?.length) && (
// //               <div className="mb-4">
// //                 <label htmlFor="state" className="mb-4 text-lightGrey text-xs">
// //                   {t('state')}
// //                 </label>
// //                 <div
// //                   className="select-none relative  rounded-lg border-transparent flex-1 appearance-none  w-full  bg-customGrey text-gray-700 cursor-pointer text-base"

// //                 >
// //                   <div
// //                     className="flex justify-between items-center py-4 px-4 "
// //                     onClick={() => setOpenState(!openState)}
// //                   >
// //                     {selectedState}
// //                   </div>
// //                   {openState && (
// //                     <div>
// //                       <div className="mt-2 max-h-40 overflow-y-auto bg-white overflow-x-hidden cursor-pointer absolute w-full left-0 shadow-md z-40">
// //                           <div>
// //                             { data?.data?.length &&
// //                               data?.data?.map(
// //                                 (state, index) => (
// //                                   <div
// //                                     onClick={() => {
// //                                       console.log();

// //                                       setSelectedState(
// //                                         `${state?.outlet?.name} (${state?.outlet?.outletState?.name})`
// //                                       );
// //                                       setSelectOutletId(state?.outlet?.id);
// //                                       setOpenState(false);
// //                                       setSelectedDate("Select date");
// //                                       setSelectedDateId(null);
// //                                       setCurrentDate(null);
// //                                       setAvailableDates(state?.examOutletBookingDates)

// //                                     }}
// //                                     className="py-2 hover:bg-gray px-4"
// //                                     key={index}
// //                                   >
// //                                     <div> {`${state?.outlet?.name} (${state?.outlet?.outletState?.name})`} </div>
// //                                   </div>
// //                                 )
// //                               )}
// //                           </div>
// //                       </div>
// //                     </div>
// //                   )}
// //                 </div>
// //               </div>
// //             )}
// //             <div className="mb-4">
// //               <label htmlFor="date" className="mb-4 text-lightGrey text-xs">
// //                 {t('date')}
// //               </label>
// //               <div
// //                 className="select-none relative  rounded-lg border-transparent flex-1 appearance-none  w-full  bg-customGrey text-gray-700 cursor-pointer text-base"

// //               >
// //                 <div
// //                   className="flex justify-between items-center py-4 px-4 "
// //                   onClick={() => setOpenDate(!openDate)}
// //                 >
// //                   { selectedDateId ? `${ new Date(selectedDate).toLocaleDateString('en-ng')}` : selectedDate}
// //                 </div>
// //                 {openDate && (
// //                   <div>
// //                     <div className="mt-2 max-h-40 overflow-y-auto bg-white overflow-x-hidden cursor-pointer absolute w-full left-0 shadow-md z-40 ">
// //                       {availableDates?.length === 0 ? (
// //                         <p className="text-center text-red-500">
// //                           {t('select-state-first')}
// //                         </p>
// //                       ) : (
// //                         <div>
// //                           {availableDates?.map((date, index) => (
// //                             <div
// //                               onClick={() => {
// //                                 setSelectedDate(date.booking_date);
// //                                 setSelectedDateId(date.id);
// //                                 setCurrentDate(date);
// //                                 setOpenDate(false);
// //                                 setSelectTimeId(null)
// //                                 setSelectedTime("Select time")
// //                                 setAvailableTimes(
// //                                   // JSON.parse(date?.preferred_time_slot)?.length ?
// //                                   //  JSON.parse(date?.preferred_time_slot) :
// //                                   (date?.preferred_time_slot)?.length ?
// //                                    (date?.preferred_time_slot) :
// //                                   []
// //                                 )
// //                               }}
// //                               className="py-2 hover:bg-gray px-4"
// //                               key={index}
// //                             >
// //                               <div> {`${ new Date(date.booking_date).toLocaleDateString('en-ng')}`} </div>
// //                             </div>
// //                           ))}
// //                         </div>
// //                       )}
// //                     </div>
// //                   </div>
// //                 )}
// //               </div>
// //             </div>
// //             <div className="mb-4">
// //               <label htmlFor="time" className="mb-6 text-lightGrey text-xs">
// //                 {t('time')}
// //               </label>
// //               <div
// //                 className="select-none relative  rounded-lg border-transparent flex-1 appearance-none  w-full  bg-customGrey text-gray-700 cursor-pointer text-base"

// //               >
// //                 <div
// //                   className="flex justify-between items-center py-4 px-4 "
// //                   onClick={() => setOpenTime(!openTime)}
// //                 >
// //                   { selectedTime !== 'Select time' ? convertTo12Hour(selectedTime) : 'Select time'}
// //                 </div>
// //                 {openTime && (
// //                   <div>
// //                     <div className="mt-2 max-h-40 overflow-y-auto bg-white overflow-x-hidden cursor-pointer absolute w-full left-0 shadow-md z-30">
// //                       { !selectedDateId ? (
// //                         <p className="text-center text-red-500">
// //                           {t('select-date-first')}
// //                         </p>
// //                       ) : (
// //                         <div>
// //                           { availableTimes?.length ?
// //                             availableTimes?.map(
// //                               (time, index) => (
// //                                 <div
// //                                   onClick={() => handleTimeSelection(time)}
// //                                   className="py-2 hover:bg-gray px-4"
// //                                   key={index}
// //                                 >
// //                                   <div>{convertTo12Hour(time)} </div>
// //                                 </div>
// //                               )
// //                             )
// //                           :
// //                           <div
// //                             className="py-2 hover:bg-gray px-4"
// //                           >
// //                             <div>{t('no-time-available')}</div>
// //                           </div>
// //                           }
// //                         </div>
// //                       )}
// //                     </div>

// //                   </div>
// //                 )}
// //               </div>
// //             </div>
// //             <div className="flex gap-x-10 justify-center">
// //               <button
// //                 type="button"
// //                 className="inline-flex justify-center rounded-md border border-darkBlue  shadow-sm px-8 py-2 md:px-16 md:py-4 bg-white text-sm font-medium text-darkBlue  sm:ml-3 sm:w-auto sm:text-sm mb-4 sm:mb-0"
// //                 onClick={() => closeModal(false)}
// //               >
// //                 {t('cancel')}
// //               </button>

// //               <button
// //                 type="submit"
// //                 className="inline-flex justify-center rounded-md border border-darkBlue  shadow-sm px-8 py-2 md:px-16 md:py-4 bg-primary text-sm font-medium text-white sm:ml-3 sm:w-auto sm:text-sm mb-4 sm:mb-0"
// //               >
// //                 {t('book')}
// //               </button>
// //             </div>
// //           </form>
// //         </div>
// //       </div>
// //     </div>
// //   );
// // }

// // export default BookexamModal;

import React, { useState } from "react";
import { useQuery, useMutation } from "react-query";
import toast from "react-hot-toast";
import { exams } from "../../../../../../api/exams";
import { useTranslation } from "react-i18next";
import { convertTo12Hour } from "../../../../../../utils/dateTimeFormatter";

function BookexamModal({ closeModal, refetch }) {
  const { t } = useTranslation();
  const user = JSON.parse(sessionStorage.getItem("user"));
  const activeExam = JSON.parse(sessionStorage.getItem("active-exam"));
  const userId = user?.user?.user_id || window.sessionStorage.getItem("user_id");
  const isEdit = activeExam?.booked_at;

  // State for cascading dropdowns
  const [selectedVenue, setSelectedVenue] = useState(null);
  const [selectedDate, setSelectedDate] = useState(null);
  const [selectedTime, setSelectedTime] = useState(null);
  const [selectedSlot, setSelectedSlot] = useState(null);

  // Dropdown open states
  const [openVenue, setOpenVenue] = useState(false);
  const [openDate, setOpenDate] = useState(false);
  const [openTime, setOpenTime] = useState(false);

  const { isLoading, data: bookings } = useQuery(
    ["get bookings"],
    async () => {
      const res = await exams.getBookingsv3(userId, activeExam?.exam_id);
      return res?.data || [];
    }
  )

  const { mutateAsync: createBooking, isLoading: isBooking } = useMutation(
    exams.createBookingv3,
    {
      onSuccess: () => {
        toast.success(t("booking-success"));
        refetch();
        closeModal(false);
      },
      onError: (error) => {
        toast.error(error?.response?.data?.error || t("booking-failed"));
      },
    }
  );

  // Get available dates for selected venue
  const availableDates = selectedVenue?.slots || [];

  // Get available times for selected date
  const availableTimes = selectedDate?.preferred_time || [];

  const handleVenueSelect = (venue) => {
    setSelectedVenue(venue);
    setSelectedDate(null);
    setSelectedTime(null);
    setSelectedSlot(null);
    setOpenVenue(false);
  };

  const handleDateSelect = (slot) => {
    setSelectedDate(slot);
    setSelectedSlot(slot);
    setSelectedTime(null);
    setOpenDate(false);
  };

  const handleTimeSelect = (time) => {
    setSelectedTime(time);
    setOpenTime(false);
  };

  const handleBook = async () => {
    if (!selectedVenue) {
      toast.error(t("please-select-venue") || "Please select a venue");
      return;
    }
    if (!selectedDate) {
      toast.error(t("please-select-date") || "Please select a date");
      return;
    }
    if (!selectedTime) {
      toast.error(t("please-select-time") || "Please select a time");
      return;
    }

    const payload = {
      slot_id: selectedSlot.id,
      preferred_time: selectedTime,
    };

    try {
      toast.loading(t("booking-loading"));
      //return console.log(payload, 'payload');
      const response = await createBooking({
        userId: userId,
        // userExamId: activeExam?.user_exam_id,
        groupId: selectedVenue.id,
        // assessmentId: activeExam?.assessment_id,
        pipelineId: activeExam?.exam_id,
        payload: { ...payload },
      });
      toast.remove();
      toast.success(response.message);
      closeModal(false);
    } catch (error) {
      toast.remove();
      toast.error(error?.response?.data?.message || t("booking-failed"));
    }
  };

  return (
    <div className="fixed top-0 left-0 w-screen h-screen grid place-items-center bg-black bg-opacity-50 p-4 md:p-10 z-50">
      <div className="w-full md:w-[600px] max-h-[90vh] overflow-y-auto bg-white rounded-2xl md:rounded-[32px] p-6 md:p-8 relative">
        <h3 className="text-2xl font-bold text-gray-900 mb-4 flex items-start justify-between">
          {t("book-exam")}
          <button
            onClick={() => closeModal(false)}
            className="bi bi-x-lg text-darkBlue px-4 md:px-6 py-2 rounded cursor-pointer"
          />
        </h3>

        {isLoading ? (
          <p className="text-center">{t("loading")}...</p>
        ) : bookings?.length ? (
          <div className="flex flex-col gap-4">
            {/* Venue Selection */}
            <div className="mb-4">
              <label className="block mb-2 text-sm font-medium text-gray-700">
                {"Select Venue"}
              </label>
              <div className="relative">
                <div
                  className="select-none rounded-lg border border-gray-300 flex-1 w-full bg-white text-gray-700 cursor-pointer text-base"
                  onClick={() => setOpenVenue(!openVenue)}
                >
                  <div className="flex justify-between items-center py-3 px-4">
                    <span className={selectedVenue ? "" : "text-gray-400"}>
                      {selectedVenue?.title || t("select-venue") || "Select Venue"}
                    </span>
                    <i className={`bi bi-chevron-${openVenue ? "up" : "down"}`}></i>
                  </div>
                </div>
                {openVenue && (
                  <div className="absolute mt-1 max-h-60 overflow-y-auto bg-white border border-gray-300 rounded-lg shadow-lg w-full z-50">
                    {bookings
                      .filter((booking) => /*booking.allow_bookings && */ booking.slots?.length > 0)
                      .map((booking) => (
                        <div
                          key={booking.id}
                          onClick={() => handleVenueSelect(booking)}
                          className="py-3 px-4 hover:bg-gray-100 cursor-pointer border-b last:border-b-0"
                        >
                          <div className="font-medium">{booking.title}</div>
                          {/*<div className="text-xs text-gray-500 mt-1">
                            {new Date(booking.start_date).toLocaleDateString()} -{" "}
                            {new Date(booking.end_date).toLocaleDateString()}
                          </div>*/}
                        </div>
                      ))}
                  </div>
                )}
              </div>
            </div>

            {/* Date Selection */}
            <div className="mb-4">
              <label className="block mb-2 text-sm font-medium text-gray-700">
                {t("select-date") || "Select Date"}
              </label>
              <div className="relative">
                <div
                  className={`select-none rounded-lg border border-gray-300 flex-1 w-full text-gray-700 text-base ${!selectedVenue ? "bg-gray-100 cursor-not-allowed" : "bg-white cursor-pointer"
                    }`}
                  onClick={() => selectedVenue && setOpenDate(!openDate)}
                >
                  <div className="flex justify-between items-center py-3 px-4">
                    <span className={selectedDate ? "" : "text-gray-400"}>
                      {selectedDate
                        ? new Date(selectedDate.assessment_date).toLocaleDateString()
                        : t("select-date") || "Select Date"}
                    </span>
                    <i className={`bi bi-chevron-${openDate ? "up" : "down"}`}></i>
                  </div>
                </div>
                {openDate && selectedVenue && (
                  <div className="absolute mt-1 max-h-60 overflow-y-auto bg-white border border-gray-300 rounded-lg shadow-lg w-full z-50">
                    {availableDates/*.filter((slot) => slot.allow_bookings)*/.length > 0 ? (
                      availableDates
                        // .filter((slot) => slot.allow_bookings)
                        .map((slot) => (
                          <div
                            key={slot.id}
                            onClick={() => handleDateSelect(slot)}
                            className="py-3 px-4 hover:bg-gray-100 cursor-pointer border-b last:border-b-0"
                          >
                            {new Date(slot.assessment_date).toLocaleDateString('en-ng')}
                          </div>
                        ))
                    ) : (
                      <div className="py-3 px-4 text-gray-500 text-center">
                        {t("no-dates-available") || "No dates available"}
                      </div>
                    )}
                  </div>
                )}
              </div>
            </div>

            {/* Time Selection */}
            <div className="mb-4">
              <label className="block mb-2 text-sm font-medium text-gray-700">
                {t("select-time") || "Select Time"}
              </label>
              <div className="relative">
                <div
                  className={`select-none rounded-lg border border-gray-300 flex-1 w-full text-gray-700 text-base ${!selectedDate ? "bg-gray-100 cursor-not-allowed" : "bg-white cursor-pointer"
                    }`}
                  onClick={() => selectedDate && setOpenTime(!openTime)}
                >
                  <div className="flex justify-between items-center py-3 px-4">
                    <span className={selectedTime ? "" : "text-gray-400"}>
                      {selectedTime
                        ? convertTo12Hour(selectedTime)
                        : t("select-time") || "Select Time"}
                    </span>
                    <i className={`bi bi-chevron-${openTime ? "up" : "down"}`}></i>
                  </div>
                </div>
                {openTime && selectedDate && (
                  <div className="absolute mt-1 max-h-60 overflow-y-auto bg-white border border-gray-300 rounded-lg shadow-lg w-full z-50">
                    {availableTimes.length > 0 ? (
                      availableTimes.map((time, index) => (
                        <div
                          key={index}
                          onClick={() => handleTimeSelect(time)}
                          className="py-3 px-4 hover:bg-gray-100 cursor-pointer border-b last:border-b-0"
                        >
                          {convertTo12Hour(time)}
                        </div>
                      ))
                    ) : (
                      <div className="py-3 px-4 text-gray-500 text-center">
                        {t("no-time-available") || "No time available"}
                      </div>
                    )}
                  </div>
                )}
              </div>
            </div>

            {/* Booking Summary */}
            {selectedVenue && selectedDate && selectedTime && (
              <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 mb-4">
                <h4 className="font-semibold text-sm mb-2">Booking Summary:</h4>
                <p className="text-sm">
                  <strong>Venue:</strong> {selectedVenue.title}
                </p>
                <p className="text-sm">
                  <strong>Date:</strong>{" "}
                  {new Date(selectedDate.assessment_date).toLocaleDateString()}
                </p>
                <p className="text-sm">
                  <strong>Time:</strong> {convertTo12Hour(selectedTime)}
                </p>
              </div>
            )}
          </div>
        ) : (
          <p className="text-center text-gray-500">
            {t("no-bookings-available")}
          </p>
        )}

        {/* Action Buttons */}
        <div className="flex justify-end gap-4 mt-6">
          <button
            onClick={() => closeModal(false)}
            className="border border-darkBlue text-darkBlue px-6 py-2 rounded hover:bg-gray-50"
          >
            {t("cancel")}
          </button>
          <button
            onClick={handleBook}
            className="bg-primary text-white px-6 py-2 rounded disabled:opacity-50 disabled:cursor-not-allowed"
            disabled={!selectedVenue || !selectedDate || !selectedTime || isBooking}
          >
            {isBooking ? t("booking-loading") || "Booking..." : t("book")}
          </button>
        </div>
      </div>
    </div>
  );
}

export default BookexamModal;